import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/assets')({
  component: RouteComponent,
  staticData: {
    authorization: {
      permission: {
        asset: ['read'],
      },
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
